module.exports = __webpack_public_path__ + "static/proverkaMini-5572ab80b5fb0c6ef962dfaac2dfdcbf.png";